import BackToBanner from 'components/back-to-banner';
import React from 'react';
import { useNavigation } from 'react-navi';
import { BackToAnywhereProps } from './back-to-anywhere-props';

/**
 * Navigates to the provided route.
 */
export const BackToAnywhere: React.FC<BackToAnywhereProps> = ({ locationName, route, state }) => {
  const navigation = useNavigation();

  const handleClick = state
    ? (event: React.MouseEvent) => {
      event.preventDefault();
      navigation.navigate(route, { state });
    }
    : undefined;

  return (
    <BackToBanner
      href={route}
      linkProps={handleClick ? { onClick: handleClick } : undefined}
    >
      {`Back to ${locationName}`}
    </BackToBanner>
  );
};
